import { Component, OnInit } from '@angular/core';

// Service imports
import { NavigationService } from '../../_services/shared-services/navigation.service';

// Model imports
import { SideNavTreeInfo } from '../../_models/side-nav-tree-info';

@Component({
    selector: 'app-navigation-quick-search',
    templateUrl: './navigation-quick-search.component.html',
    styleUrls: ['./navigation-quick-search.component.scss']
})
export class NavigationQuickSearchComponent implements OnInit {
    sideNavTree: SideNavTreeInfo[];
    searchedItems: SideNavTreeInfo[];
    searchText: string;
    searchButton: object;

    constructor(private readonly navigationService: NavigationService) {}

    ngOnInit() {
        this.searchButton = {
            icon: 'fas fa-search',
            stylingMode: 'text',
            width: 32,
            height: 32,
            elementAttr: {
                class: 'cc-search-button'
            }
        };
    }

    onTextValueChanged(event): void {
        this.triggerSearch();
    }

    onEnterKey(event): void {
        this.triggerSearch();
    }

    private triggerSearch(): void {
        if (this.searchText) {
            this.navigationService.updateSearchedItem(this.searchText);
        } else {
            this.navigationService.updateSearchedItem(null);
        }
    }
}
